/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_Meta_DescInputs */

const en_wc_dl_meta_desc = /** @type {(inputs: Wc_Dl_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Official WordCraft download links for Windows, macOS, Linux and FreeBSD, with step-by-step install guide, checksums and troubleshooting for ArtCraft WordCraft.`)
};

/**
* | output |
* | --- |
* | "Official WordCraft download links for Windows, macOS, Linux and FreeBSD, with step-by-step install guide, checksums and troubleshooting for ArtCraft WordCraft." |
*
* @param {Wc_Dl_Meta_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_meta_desc = /** @type {((inputs?: Wc_Dl_Meta_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_Meta_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_meta_desc(inputs)
});
export { wc_dl_meta_desc as "wc.dl.meta_desc" }